import { Icon } from "../../Icon";
import { IIcon } from "../../interfaces/IIcon";

export const archiveIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="3"/><path fill="#FFF" d="M38 14H17v36h30V23l-9-9zm0 4.5l4.5 4.5H38v-4.5zM20 47V17h15v9h9v21H20zm9.999-18l1.389 6.75c.588 2.364-1.198 3.75-3.637 3.75-2.436 0-4.227-1.383-3.638-3.75L25.502 29h4.497zm-4.497 7.594c0 1.896 4.494 1.91 4.494-.004 0-2.012-4.494-1.967-4.494.004zM29.999 26v1.5h-4.497V26h4.497zm0-3v1.5h-4.497V23h4.497zm0-3v1.5h-4.497V20h4.497zm0-3v1.5h-4.497V17h4.497z"/></svg>`
);
